module.exports = __webpack_public_path__ + "img/Edit-assumptions.2acd15d9.svg";